import type { GeneratedDocumentation } from './contracts';

function safe(value: string): string {
  return value.replace(/[<>]/g, '').trim();
}

function metricValue(value: unknown, unit: string): string {
  if (typeof value !== 'number') return 'Desconhecido';
  if (unit === 'ratio') return `${(value * 100).toFixed(1)}%`;
  if (unit === 'money_minor')
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
      value / 100,
    );
  return new Intl.NumberFormat('pt-BR').format(value);
}

export function buildDocumentationMarkdown(name: string, document: GeneratedDocumentation): string {
  const lines = [
    `# ${safe(name)}`,
    '',
    '## Visão geral',
    '',
    safe(document.overview.content),
    '',
    '## Objetivo',
    '',
  ];
  const objective = document.objective.content;
  lines.push(objective ? safe(objective.objective) : 'Não definido.');
  if (objective?.metric) lines.push('', `- Métrica: ${safe(objective.metric)}`);
  if (objective?.target !== undefined)
    lines.push(`- Meta: ${objective.target}${objective.unit ? ` ${safe(objective.unit)}` : ''}`);
  if (objective?.period) lines.push(`- Período: ${safe(objective.period)}`);
  lines.push('', '## Etapas', '');
  for (const stage of document.stages.content)
    lines.push(
      `### ${safe(stage.name)}`,
      '',
      safe(stage.description ?? 'Descrição não informada.'),
      '',
      `- Tipo: ${safe(stage.type)}`,
      `- Responsável: ${safe(stage.responsible ?? 'Não definido')}`,
    );
  lines.push('', '## Responsabilidades', '');
  for (const item of document.responsibilities.content)
    lines.push(`- ${safe(item.responsible)}: ${item.stages.map(safe).join(', ')}`);
  lines.push('', '## Sistemas', '');
  for (const item of document.systems.content)
    lines.push(`- ${safe(item.name)} — ${safe(item.role)}`);
  lines.push('', '## KPIs', '');
  for (const item of document.kpis.content)
    lines.push(
      `- ${safe(item.label)}: ${metricValue(item.current.effectiveValue, item.unit)}${item.target !== undefined ? ` (meta: ${item.target})` : ''}`,
    );
  lines.push(
    '',
    '## POP',
    '',
    `### ${safe(document.sop.content.title)}`,
    '',
    safe(document.sop.content.purpose),
    '',
  );
  for (const step of document.sop.content.steps)
    lines.push(
      `${step.order}. **${safe(step.title)}** — ${safe(step.description)}${step.responsible ? ` (Responsável: ${safe(step.responsible)})` : ''}${step.branch ? ` Ramificações: ${safe(step.branch)}.` : ''}`,
    );
  lines.push('', '## Checklist', '');
  for (const item of document.checklist.content)
    lines.push(`- [ ] ${safe(item.label)}${item.required ? ' (obrigatório)' : ''}`);
  if (document.attentionPoints) {
    lines.push('', '## Pontos de atenção', '');
    for (const item of document.attentionPoints.content)
      lines.push(
        `- **${safe(item.title)}** (${safe(item.severity)}): ${item.evidence.map(safe).join('; ')}`,
      );
  }
  lines.push(
    '',
    '---',
    `Gerado pelo Dark Funnels · Cobertura: ${document.coverage.complete}/${document.coverage.total}`,
    '',
  );
  return lines.join('\n');
}
